/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { useState } from 'react';
import dayjs from 'dayjs'
import OrganizationDropdownCorpWithSearch from './dropdownWithSearchForPatient'
import DropdownForUserFilter from './dropdownWithSearchForUser';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import { handleEmptyUsersDropdown, handleFillFromSearchParamsUsers, resetOrgList as resetOrgUserList, resetTempFilterUsersOpen } from '../../../../redux/wellnessFilterUserSlice';
import { handleEmptyDropdown, handleFillFromSearchParamsPatients, resetOrgList, resetTempFilterOpen } from '../../../../redux/wellnessFilterSlice';
export default function FilterBtn({dateError,setdateError,isFilterOpen,setIsFilterOpen,isFilterOrganization,initialState,filterValues,setFilterValues,handleOpenFilter,selectedOrganizationName,setSelectedOrganizationName,setSubDivisionDataLoading,subDivisionDataLoading,userArr,isPatientSearch}) {

    const totalUsers = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.totalUsers)
    const totalPatients = useSelector(state=>state.filterSelect.selectedUsers.totalUsers)
    const [searchParams,setSearchParams] = useSearchParams()
    const redioButtonStatus = ["Qualified", "Disqualified"]
    const selectedPatients = useSelector(state=>state.filterSelect.selectedUsers.selectedArr)
    const unselectedPatients = useSelector(state=>state.filterSelect.selectedUsers.unselectedArr)
    const isCheckedPatients = useSelector(state=>state.filterSelect.selectedUsers.isCheckedAll)
    const selectedUserNames = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.selectedArr)
    const unselectedUserNames = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.unselectedArr)
    const isCheckedUsers = useSelector(state=>state.filterUserNameSelect.selectedFilterUsers.isCheckedUsersAll)
    const [isSelectAllChecked,setIsSelectAllChecked] = useState(searchParams.get('selected_patient_ids')?false:true)
    const [isSearchedSelectAllChecked,setIsSearchedSelectAllChecked] = useState(true)
    const [isSelectAllUsersChecked,setisSelectAllUsersChecked] = useState(searchParams.get('selected_user_ids')?false:true)
    const [isSearchedSelectAllUsersChecked,setisSearchedSelectAllUsersChecked] = useState(true)
    const [suggestions,setSuggestions] = useState('')
    const dispatch = useDispatch()
    const [usersuggestions,setusersuggestions] = useState('')
    const handleCheckboxChange = (status) => {
        // Check if the status is already in the array
        const index = filterValues?.status?.indexOf(status);
        if(filterValues.status===undefined){
            setFilterValues((prevFilter) => ({
                ...prevFilter,
                status: [status],
            }));
            return
        }
        if (index === -1) {
            // If the status is not in the array, add it
            setFilterValues((prevFilter) => ({
                ...prevFilter,
                status: [...prevFilter?.status, status],
            }));
        } else {
            // If the status is already in the array, remove it
            setFilterValues((prevFilter) => ({
                ...prevFilter,
                status: prevFilter?.status?.filter((s) => s !== status),
            }));
        }
    };
  
    const handleCheck=()=>{
        if((dayjs(filterValues?.end_date).isBefore(dayjs(filterValues?.start_date)))&&(filterValues?.end_date!==undefined&&filterValues.start_date!==undefined)){
            return true
        }
        return false
    }
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        
        if (type) {
            // params.filter = "true";
            // Dispatch the filter values to Redux

            if((!isSelectAllChecked&&selectedPatients?.length===0&&unselectedPatients?.length===0)||(!isSelectAllUsersChecked&&selectedUserNames?.length===0&&unselectedUserNames?.length===0)){
                params.unselected_patient_ids!==null&&delete params.unselected_patient_ids
                params.selected_patient_ids!==null&&delete params.selected_patient_ids
                params.unselected_user_ids!==null&&delete params.unselected_user_ids
                params.selected_user_ids!==null&&delete params.selected_user_ids
                !(isSelectAllChecked)&&selectedPatients?.length===0?params.selected_patient_ids="empty":''
                !(isSelectAllUsersChecked)&&selectedUserNames?.length===0?params.selected_user_ids="empty":''
            }else if((isSelectAllChecked&&selectedPatients?.length===0&&unselectedPatients?.length===0)||(isSelectAllUsersChecked&&selectedUserNames?.length===0&&unselectedUserNames?.length===0)){
                params.selected_patient_ids!==null&&delete params.selected_patient_ids
                params.selected_user_ids!==null&& delete params.selected_user_ids
            }
            params.page_number=1
            if(isSelectAllChecked&&unselectedPatients?.length===0){
                if(searchParams.get('unselected_patient_ids')!==null){
                    delete params.unselected_patient_ids
                }
            }
            if(!isSelectAllChecked&&selectedPatients?.length===0){
               
                if(searchParams.get('selected_patient_ids')!==null&&searchParams.get('selected_patient_ids')!=='empty'){
                    delete params.selected_patient_ids
                }
            }
            if(!isSelectAllChecked&&unselectedPatients?.length!==0){
                
                if(searchParams.get('selected_patient_ids')!==null){
                    params.selected_patient_ids='empty'
                }
            }
            if(isSelectAllChecked&&unselectedPatients?.length!==0){
                
                if(searchParams.get('selected_patient_ids')!==null){
                    delete params.selected_patient_ids
                }
                params['unselected_patient_ids']=unselectedPatients.join(',')
            }else if(!isSelectAllChecked&&selectedPatients?.length!==0){
                if(searchParams.get('unselected_patient_ids')!==null){
                    delete params.unselected_patient_ids
                }
                params['selected_patient_ids']=selectedPatients.join(',')
            }


            if(isSelectAllUsersChecked&&unselectedUserNames?.length===0){
                if(searchParams.get('unselected_user_ids')!==null){
                    delete params.unselected_user_ids
                }
            }
            if(!isSelectAllUsersChecked&&selectedUserNames?.length===0){
                if(searchParams.get('selected_user_ids')!==null&&searchParams.get('selected_user_ids')!=='empty'){
                    delete params.selected_user_ids
                }
            }
            if(!isSelectAllUsersChecked&&unselectedUserNames?.length!==0){
                if(searchParams.get('selected_user_ids')!==null){
                    params.selected_user_ids='empty'
                }
            }
           
            if(isSelectAllUsersChecked&&unselectedUserNames?.length!==0){
                if(searchParams.get('selected_user_ids')!==null){
                    delete params.selected_user_ids
                }
                params['unselected_user_ids']=unselectedUserNames.join(',')
            }else if(!isSelectAllUsersChecked&&selectedUserNames?.length!==0){
                if(searchParams.get('unselected_user_ids')!==null){
                    delete params.unselected_user_ids
                }
                params['selected_user_ids']=selectedUserNames.join(',')
            }
            if(filterValues?.status?.length>0){
                params.status=filterValues?.status.join(',')
            }
            if(filterValues?.status?.length==0&& params['status']!==null){
                delete params.status
            }

            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues((prev)=>({
                ...prev,
                'status':[]
            }));
            setIsSelectAllChecked(true)
            setisSelectAllUsersChecked(true)
            dispatch(resetTempFilterOpen())
            dispatch(resetTempFilterUsersOpen())
            // Remove filter-related keys from searchParams
            
            // delete params['filter'];
            params["status"]&& delete params["status"]
            
            params?.selected_user_ids&&delete params.selected_user_ids
            params?.unselected_user_ids&&delete params.unselected_user_ids
            params?.selected_patient_ids&&delete params.selected_patient_ids
            params?.unselected_patient_ids&&delete params.unselected_patient_ids
   
            setSearchParams({ ...params });
        }
    };
    
    
    const handlePlaceHolder =(Username) => {
        let displayNumber=''
        if(Username===undefined){
            if(suggestions.trim()===''){
                if(!isSelectAllChecked&&selectedPatients[0]==='empty'||totalPatients===0){
                    return `Select patient name`
                }
                if(isCheckedPatients&&(unselectedPatients?.length==0&&selectedPatients?.length===0)){
                    displayNumber = totalPatients
                    return `${displayNumber} Selected`
                }else if(!isCheckedPatients&&suggestions.trim()===''&&(selectedPatients.length===0&&unselectedPatients.length===0)){
                    return `Select patient name`
                }else if(isSelectAllChecked&&(unselectedPatients?.length>0||selectedPatients?.length>0)){
                    return `${totalPatients-unselectedPatients.length} Selected`
                }else if(!isSelectAllChecked&&(unselectedPatients?.length>0||selectedPatients?.length>0)){
                    return `${selectedPatients?.length} Selected`
                }
            }else{
                if(!isSelectAllChecked&&selectedPatients[0]==='empty'){
                    return `Select patient name`
                }
                
                if(isSelectAllChecked){
                    return `${totalPatients-unselectedPatients.length} Selected`
                }
                else if(!isSelectAllChecked){
                    return `${selectedPatients?.length} Selected`
                }
            }
            
        }else{
            if(usersuggestions.trim()===''){
                if(!isSelectAllUsersChecked&&selectedUserNames[0]==='empty'||totalUsers===0){
                    return `Select user name`
                }
                if(isCheckedUsers&&(unselectedUserNames?.length==0&&selectedUserNames?.length===0)){
                    return `${totalUsers} Selected`
                }else if(!isCheckedUsers&&usersuggestions.trim()===''&&(selectedUserNames.length===0&&unselectedUserNames.length===0)){
                    return `Select user name`
                }else if(isSelectAllUsersChecked&&(unselectedUserNames?.length>0||selectedUserNames?.length>0)){
                    return `${totalUsers-unselectedUserNames.length} Selected`
                }else if(!isSelectAllUsersChecked&&(unselectedUserNames?.length>0||selectedUserNames?.length>0)){
                    return `${selectedUserNames?.length} Selected`
                }
            }else{
                if(!isSelectAllUsersChecked&&selectedUserNames[0]==='empty'){
                    return `Select user name`
                }
                if(isSelectAllUsersChecked){
                    return `${totalUsers-unselectedUserNames.length} Selected`
                }else if(!isSelectAllUsersChecked){
                    return `${selectedUserNames?.length} Selected`
                }
               
            }
        }
       

    }
    useEffect(()=>{
        !isFilterOpen?dispatch(resetTempFilterOpen()):''
        !isFilterOpen?dispatch(resetTempFilterUsersOpen()):''
        !isFilterOpen&&setFilterValues((prev)=>({...prev,status:[]}))
        if(isFilterOpen){
            if(searchParams.get('selected_patient_ids')===null&&searchParams.get('unselected_patient_ids')===null){
                setIsSelectAllChecked(true)
            }
            if(searchParams.get('selected_patient_ids')==='empty'){
                setIsSelectAllChecked(false)
            }
            if(searchParams.get('selected_user_ids')===null&&searchParams.get('unselected_user_ids')===null){
                setisSelectAllUsersChecked(true)
            }
            if(searchParams.get('selected_user_ids')==='empty'){
                setisSelectAllUsersChecked(false)
            }
            if(searchParams.get('selected_patient_ids')==='empty'||searchParams.get('selected_user_ids')==='empty'){
                searchParams.get('selected_patient_ids')==='empty'?dispatch(handleEmptyDropdown()):''
                searchParams.get('selected_user_ids')==='empty'?dispatch(handleEmptyUsersDropdown()):''
            }
            if(searchParams.get('selected_patient_ids')&&!(searchParams.get('selected_patent_ids')==='empty')){
                dispatch(handleFillFromSearchParamsPatients([decodeURIComponent(searchParams.get('selected_patient_ids')).split(',')?.filter(item=>item!=='empty'),[]]))
            }else if(searchParams.get('unselected_patient_ids')){
                dispatch(handleFillFromSearchParamsPatients([[],decodeURIComponent(searchParams.get('unselected_patient_ids')).split(',')?.filter(item=>item!=='empty')]))
            }

            if(searchParams.get('selected_user_ids')&&!(searchParams.get('selected_user_ids')==='empty')){
                dispatch(handleFillFromSearchParamsUsers([decodeURIComponent(searchParams.get('selected_user_ids')).split(',')?.filter(item=>item!=='empty'),[]]))
            }else if(searchParams.get('unselected_user_ids')){
                dispatch(handleFillFromSearchParamsUsers([[],decodeURIComponent(searchParams.get('unselected_user_ids')).split(',')?.filter(item=>item!=='empty')]))
            }
            if(searchParams.get('status')){
                setFilterValues((prev)=>({
                    ...prev,
                    status:decodeURIComponent(searchParams.get('status')).split(',')
                }))
            }
        }
    },[isFilterOpen])
 
    return (
        <div className='xl:relative ml-2.5'>
            <button id='filter' data-testid={'filter-btn'} type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2 min-w-max' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen && 
               
                    <div  className=' absolute top-[112px] xl:top-14 filter_top right-0  left-auto bg-white rounded-[15px] border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[494px] z-[99]'>
                        <div className='flex justify-between items-center mb-4'>
                            <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                            {dateError &&<p className="text-xs text-red-500 mt-2 mr-8">Please select the valid date range.</p>}
                            <button type='button' onClick={()=>{setIsFilterOpen(!isFilterOpen),setdateError(false)}}>
                                <img src="/images/cross_mark_gray.svg" alt="icon" />
                            </button>
                        </div>
                        <div className='flex flex-wrap -mx-2'>
                            <div className={`w-1/2 px-2 mb-4`}>
                                <div className="w-full">
                                    <OrganizationDropdownCorpWithSearch
                                        label={"Patient Name"}
                                        id={`patient_name`}
                                        placeholder={handlePlaceHolder()}
                                        disabled={false}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.organization_name}
                                        setFilterValues={setFilterValues}
                                        filterValues={filterValues}
                                        index={0}
                                        value={''}
                                        isSelectAllChecked={isSelectAllChecked}
                                        setIsSelectAllChecked={setIsSelectAllChecked}
                                        // adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                        suggestions={suggestions}
                                        setSuggestions={setSuggestions}
                                        isSearchedSelectAllChecked={isSearchedSelectAllChecked}
                                        setIsSearchedSelectAllChecked={setIsSearchedSelectAllChecked}
                                    />
                                </div>
                            </div>
                            <div className={`w-1/2 px-2 mb-4`}>
                                <div className="w-full">
                                    <DropdownForUserFilter
                                        label={"User Name"}
                                        id={`user_name`}
                                        placeholder={handlePlaceHolder('Username')}
                                        disabled={false}
                                        filterValues={filterValues}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.organization_name}
                                        setFilterValues={setFilterValues}
                                        index={0}
                                        value={''}
                                        isSelectAllUsersChecked={isSelectAllUsersChecked}
                                        setisSelectAllUsersChecked={setisSelectAllUsersChecked}
                                        isSearchedSelectAllUsersChecked={isSearchedSelectAllUsersChecked}
                                        setisSearchedSelectAllUsersChecked={setisSearchedSelectAllUsersChecked}
                                        // adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                        usersuggestions={usersuggestions}
                                        setusersuggestions={setusersuggestions}
                                    />
                                </div>
                            </div>
                            <div className='w-full px-2.5 mb-[5px]'>
                                <p className='text-xs font-semibold text-[#000000] pb-1.5'>Status</p>
                                <div className='flex items-center'>
                                    {redioButtonStatus.map((item,index) =>
                                        (<div className="p-2" key={item}>
                                            <div className="relative checkbox custom-checkBoxBlue1 provider-tbody device-status">
                                                <input 
                                                    id={index}
                                                    data_testid={`${item==='Qualified'?'qualified-check':'unquaified-check'}`} 
                                                    type="checkbox" 
                                                    name="default-checkbox" 
                                                    checked={(filterValues?.status) && filterValues?.status.includes(item)} 
                                                    onChange={() => handleCheckboxChange(item)} 
                                                />
                                                <label htmlFor={index}  id={item} data-testid={`${item==='Qualified'?'qualified':'unqualified'}`} className="text-base font-normal text-[#000] pl-5 w-full cursor-pointer">
                                                    {item}
                                                </label>
                                            </div>
                                        </div>))}
                                </div>
                            </div>
                        </div>
                        <div className="flex mt-[13px] justify-between">
                            <button  onClick={()=>{handleApplyFilter(false),setIsFilterOpen(false)}}
                                id="clear-button"
                                data-testid={'clear-btn'}
                                className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] mr-[38px]" 
                            >Clear All</button>
                            <button  
                                onClick={()=>{
                                    
                                    handleApplyFilter(true),setIsFilterOpen(false)}}
                                type='button'
                                id="apply-filter"
                                data-testid="apply-btn"
                                disabled={(selectedPatients?.length===0&&unselectedPatients?.length===0&&!isSelectAllChecked)&&(selectedUserNames?.length===0&&unselectedUserNames?.length===0&&!isSelectAllUsersChecked)&&filterValues?.status?.length===0} 
                                className={`py-2.5 w-[106px] px-4 rounded-[16px]  ${(selectedPatients?.length===0&&unselectedPatients?.length===0&&!isSelectAllChecked)&&(selectedUserNames?.length===0&&unselectedUserNames?.length===0&&!isSelectAllUsersChecked)&&filterValues?.status?.length===0?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'}   text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                                Apply
                            </button>
                        </div>
                    </div>
                // </motion.div>
            }
        </div>  
    )
}
